var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Modal components")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-1",
            modifiers: {
              "collapse-1": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Below is a "), _c('em', [_vm._v("static")]), _vm._v(" modal example (meaning its "), _c('code', [_vm._v("position")]), _vm._v(" and "), _c('code', [_vm._v("display")]), _vm._v(" have been overridden). Included are the modal header, modal body (required for "), _c('code', [_vm._v("padding")]), _vm._v("), and modal footer (optional). We ask that you include modal headers with dismiss actions whenever possible, or provide another explicit dismiss action.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-1"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "modal-components-1"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-button v-b-modal.modal-1 variant=\"primary\">Launch demo modal</b-button>\n<b-modal id=\"modal-1\" title=\"Modal title\" ok-title=\"Save Changes\" cancel-title=\"Close\">\n  ...\n</b-modal>\n")])])])])]), _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-1",
            modifiers: {
              "modal-1": true
            }
          }],
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Launch demo modal")]), _c('b-modal', {
          attrs: {
            "id": "modal-1",
            "title": "Modal title",
            "ok-title": "Save Changes",
            "cancel-title": "Close"
          }
        }, [_vm._v(" ... ")])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Modal Scrolling")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-2",
            modifiers: {
              "collapse-2": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("When modals become too long for the user’s viewport or device, they scroll independent of the page itself. Try the demo below to see what we mean.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-2"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "modal-scrolling"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-button v-b-modal.modal-2 variant=\"primary\">Launch demo modal</b-button>\n<b-modal id=\"modal-2\" scrollable title=\"Modal title\" ok-title=\"Save Changes\" cancel-title=\"Close\">\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n</b-modal>\n")])])])])]), _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-2",
            modifiers: {
              "modal-2": true
            }
          }],
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Launch demo modal")]), _c('b-modal', {
          attrs: {
            "id": "modal-2",
            "scrollable": "",
            "title": "Modal title",
            "ok-title": "Save Changes",
            "cancel-title": "Close"
          }
        }, [_c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")]), _c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")]), _c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")]), _c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")]), _c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")]), _c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Optional sizes")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-3",
            modifiers: {
              "collapse-3": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Modals have three optional sizes, available via modifier classes to be placed on a .modal-dialog. These sizes kick in at certain breakpoints to avoid horizontal scrollbars on narrower viewports.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-3"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "modal-components-2"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-button v-b-modal.modal-3 variant=\"primary\">Extra large modal</b-button>\n<b-button v-b-modal.modal-4 variant=\"primary\">Large modal</b-button>\n<b-button v-b-modal.modal-5 variant=\"primary\">Small modal</b-button>\n\n<b-modal id=\"modal-3\" size=\"xl\" title=\"Modal title\" ok-title=\"Save Changes\" cancel-title=\"Close\">\n  <p>Modal body text goes here.</p>\n</b-modal>\n\n<b-modal id=\"modal-4\" size=\"lg\" title=\"Modal title\" ok-title=\"Save Changes\" cancel-title=\"Close\">\n  <p>Modal body text goes here.</p>\n</b-modal>\n\n<b-modal id=\"modal-5\" size=\"sm\" title=\"Modal title\" ok-title=\"Save Changes\" cancel-title=\"Close\">\n  <p>Modal body text goes here.</p>\n</b-modal>\n")])])])])]), _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-3",
            modifiers: {
              "modal-3": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Extra large modal")]), _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-4",
            modifiers: {
              "modal-4": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Large modal")]), _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-5",
            modifiers: {
              "modal-5": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Small modal")]), _c('b-modal', {
          attrs: {
            "id": "modal-3",
            "size": "xl",
            "title": "Modal title",
            "ok-title": "Save Changes",
            "cancel-title": "Close"
          }
        }, [_c('p', [_vm._v("Modal body text goes here.")])]), _c('b-modal', {
          attrs: {
            "id": "modal-4",
            "size": "lg",
            "title": "Modal title",
            "ok-title": "Save Changes",
            "cancel-title": "Close"
          }
        }, [_c('p', [_vm._v("Modal body text goes here.")])]), _c('b-modal', {
          attrs: {
            "id": "modal-5",
            "size": "sm",
            "title": "Modal title",
            "ok-title": "Save Changes",
            "cancel-title": "Close"
          }
        }, [_c('p', [_vm._v("Modal body text goes here.")])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Scrolling long content")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-4",
            modifiers: {
              "collapse-4": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("When modals become too long for the user’s viewport or device, they scroll independent of the page itself. Try the demo below to see what we mean.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-4"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "scroll-long-components"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-button v-b-modal.modal-6 variant=\"primary\">Launch demo modal</b-button>\n<b-modal id=\"modal-6\" title=\"Modal title\" ok-title=\"Save Changes\" cancel-title=\"Close\">\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n</b-modal>\n")])])])])]), _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-6",
            modifiers: {
              "modal-6": true
            }
          }],
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Launch demo modal")]), _c('b-modal', {
          attrs: {
            "id": "modal-6",
            "title": "Modal title",
            "ok-title": "Save Changes",
            "cancel-title": "Close"
          }
        }, [_c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")]), _c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")]), _c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")]), _c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")]), _c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")]), _c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Vertically centered")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-5",
            modifiers: {
              "collapse-5": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Add "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".modal-dialog-centered")]), _vm._v(" to "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".modal-dialog")]), _vm._v(" to vertically center the modal.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-5"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "vertical-center"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-button v-b-modal.modal-7 variant=\"primary\">Launch demo modal</b-button>\n<b-button v-b-modal.modal-8 variant=\"primary\">Vertically centered scrollable modal</b-button>\n<b-modal id=\"modal-7\" centered title=\"Modal title\" ok-title=\"Save Changes\" cancel-title=\"Close\">\n  ...\n</b-modal>\n<b-modal id=\"modal-8\" centered title=\"Modal title\" ok-title=\"Save Changes\" cancel-title=\"Close\">\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n  <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>\n  <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>\n  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>\n</b-modal>\n")])])])])]), _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-7",
            modifiers: {
              "modal-7": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Launch demo modal")]), _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-8",
            modifiers: {
              "modal-8": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Vertically centered scrollable modal")]), _c('b-modal', {
          attrs: {
            "id": "modal-7",
            "centered": "",
            "title": "Modal title",
            "ok-title": "Save Changes",
            "cancel-title": "Close"
          }
        }, [_vm._v(" ... ")]), _c('b-modal', {
          attrs: {
            "id": "modal-8",
            "centered": "",
            "title": "Modal title",
            "ok-title": "Save Changes",
            "cancel-title": "Close"
          }
        }, [_c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")]), _c('p', [_vm._v("Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")]), _c('p', [_vm._v("Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.")]), _c('p', [_vm._v("Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.")])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Using the grid")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-6",
            modifiers: {
              "collapse-6": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Utilize the Bootstrap grid system within a modal by nesting "), _c('code', [_vm._v(".container-fluid")]), _vm._v(" within the "), _c('code', [_vm._v(".modal-body")]), _vm._v(". Then, use the normal grid system classes as you would anywhere else.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-6"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "using-grid"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-button v-b-modal.modal-9 variant=\"primary\">Launch demo modal</b-button>\n<b-modal id=\"modal-9\" centered title=\"Modal title\" ok-title=\"Save Changes\" cancel-title=\"Close\">\n  <div class=\"iq-example-row\">\n    <b-container fluid>\n      <b-row class=\"mb-3\">\n        <b-col md=\"4\">\n          md=\"4\"\n        </b-col>\n        <b-col md=\"4\" class=\"ml-auto\">\n          md=\"4\" .ml-auto\n        </b-col>\n      </b-row>\n      <b-row class=\"mb-3\">\n        <b-col md=\"3\" class=\"ml-auto\">md=\"3\" .ml-auto</b-col>\n        <b-col md=\"2\" class=\"ml-auto\">md=\"2\" .ml-auto</b-col>\n      </b-row>\n      <b-row class=\"mb-3\">\n        <b-col md=\"6\" class=\"ml-auto\">md=\"6\" .ml-auto</b-col>\n      </b-row>\n      <b-row>\n        <b-col sm=\"9\">\n          Level 1: sm=\"9\"\n          <b-row>\n            <b-col cols=\"8\" sm=\"6\">Level 2: cols=\"8\" sm=\"6\"</b-col>\n            <b-col cols=\"4\" sm=\"6\">Level 2: cols=\"4\" sm=\"6\"</b-col>\n          </b-row>\n        </b-col>\n      </b-row>\n    </b-container>\n  </div>\n</b-modal>\n")])])])])]), _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-9",
            modifiers: {
              "modal-9": true
            }
          }],
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Launch demo modal")]), _c('b-modal', {
          attrs: {
            "id": "modal-9",
            "centered": "",
            "title": "Modal title",
            "ok-title": "Save Changes",
            "cancel-title": "Close"
          }
        }, [_c('div', {
          staticClass: "iq-example-row"
        }, [_c('b-container', {
          attrs: {
            "fluid": ""
          }
        }, [_c('b-row', {
          staticClass: "mb-3"
        }, [_c('b-col', {
          attrs: {
            "md": "4"
          }
        }, [_vm._v(" md=\"4\" ")]), _c('b-col', {
          attrs: {
            "md": "4 ml-auto"
          }
        }, [_vm._v(" md=\"4\" .ml-auto ")])], 1), _c('b-row', {
          staticClass: "mb-3"
        }, [_c('b-col', {
          attrs: {
            "md": "3 ml-auto"
          }
        }, [_vm._v("md=\"3\" .ml-auto")]), _c('b-col', {
          attrs: {
            "md": "2 ml-auto"
          }
        }, [_vm._v("md=\"2\" .ml-auto")])], 1), _c('b-row', {
          staticClass: "mb-3"
        }, [_c('b-col', {
          attrs: {
            "md": "6 ml-auto"
          }
        }, [_vm._v("md=\"6\" .ml-auto")])], 1), _c('b-row', [_c('b-col', {
          attrs: {
            "sm": "9"
          }
        }, [_vm._v(" Level 1: sm=\"9\" "), _c('b-row', [_c('b-col', {
          attrs: {
            "cols": "8",
            "sm": "6"
          }
        }, [_vm._v("Level 2: cols=\"8\" sm=\"6\"")]), _c('b-col', {
          attrs: {
            "cols": "4",
            "sm": "6"
          }
        }, [_vm._v("Level 2: cols=\"4\" sm=\"6\"")])], 1)], 1)], 1)], 1)], 1)])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }